import { DiscussionCache } from "@vladrss/core";
import { onSessionReset } from "./session";
export { DiscussionCache } from "@vladrss/core";

export const discussions = new DiscussionCache();
onSessionReset(() => discussions.clear());
